import { firebase } from 'common/src/config/configureFirebase';

/**
 * Agrega X-Firebase-AppCheck a las llamadas del panel a Cloud Functions.
 * Solo en peticiones del mismo dominio (rewrites de Hosting): en otros dominios el header extra
 * dispararía un preflight CORS que esos endpoints no aceptan.
 */
export function installAppCheckFetch() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function' || window.fetch.__appCheck) return;
  const originalFetch = window.fetch.bind(window);

  const fetchWithAppCheck = async (input, init) => {
    try {
      const rawUrl = typeof input === 'string' ? input : input && input.url;
      const url = new URL(rawUrl, window.location.href);
      if (url.origin === window.location.origin && typeof firebase.getAppCheckToken === 'function') {
        const token = await firebase.getAppCheckToken();
        if (token) {
          const headers = new Headers((init && init.headers) || (typeof input !== 'string' && input.headers) || undefined);
          headers.set('X-Firebase-AppCheck', token);
          return originalFetch(input, { ...(init || {}), headers });
        }
      }
    } catch (e) {
      // Sin token se envía la petición igual (fase de observación).
    }
    return originalFetch(input, init);
  };

  fetchWithAppCheck.__appCheck = true;
  window.fetch = fetchWithAppCheck;
}
